export default function ({ store, redirect }) {
  if (store.getters['system/isIPAllowed']) {
    return redirect('/');
  }
}
